import { j as e } from "./atoms-v218.js";
import { Wrapper as j, Header as u, Title as s, RateName as m, RateDescription as v, Section as o, SubSection as l, SubSectionItem as p, TaxBlock as a, PoliciesText as b } from "./atoms-v21039.js";
import { Text as n } from "./atoms-v243.js";
import $ from "./atoms-v2780.js";
const T = ({
  addons: x = [],
  colorTheme: r,
  language: d,
  rate: i,
  roomName: h,
  totalAddonPrice: y,
  translations: t
}) => /* @__PURE__ */ e.jsxs(j, { children: [
  /* @__PURE__ */ e.jsxs(u, { $colorTheme: r, children: [
    /* @__PURE__ */ e.jsx(s, { $colorTheme: r, children: h }),
    /* @__PURE__ */ e.jsx(m, { $colorTheme: r, children: i.name }),
    /* @__PURE__ */ e.jsx(v, { $colorTheme: r, children: i.description })
  ] }),
  /* @__PURE__ */ e.jsxs(o, { $colorTheme: r, children: [
    /* @__PURE__ */ e.jsx(s, { $colorTheme: r, children: t.basePriceLabel }),
    /* @__PURE__ */ e.jsx(l, { children: i.nightly_rates.map((c) => /* @__PURE__ */ e.jsxs(p, { children: [
      /* @__PURE__ */ e.jsx(n, { type: "body", variant: "productive", children: $(new Date(c.date), "MMM dd, yyyy") }),
      /* @__PURE__ */ e.jsx(n, { type: "body", variant: "productive", children: c.amount_after_tax.toLocaleString(d, {
        currency: i.currency_code,
        style: "currency"
      }) })
    ] }, `${c.date}-nightly-rate`)) })
  ] }),
  x.length > 0 && /* @__PURE__ */ e.jsxs(o, { $colorTheme: r, children: [
    /* @__PURE__ */ e.jsx(s, { $colorTheme: r, children: t.addonsLabel }),
    /* @__PURE__ */ e.jsx(l, { children: x.map((c) => /* @__PURE__ */ e.jsxs(p, { children: [
      /* @__PURE__ */ e.jsx(a, { children: /* @__PURE__ */ e.jsx(n, { type: "body", variant: "productive", children: c.title }) }),
      /* @__PURE__ */ e.jsx(n, { type: "body", variant: "productive", children: c.price.toLocaleString(d, {
        currency: i.currency_code,
        style: "currency"
      }) })
    ] }, `${c.title}-addon`)) })
  ] }),
  /* @__PURE__ */ e.jsxs(o, { $colorTheme: r, children: [
    /* @__PURE__ */ e.jsx(s, { $colorTheme: r, children: t.taxesAndFeesLabel }),
    /* @__PURE__ */ e.jsx(l, { children: i.taxes.map((c) => /* @__PURE__ */ e.jsxs(p, { children: [
      /* @__PURE__ */ e.jsxs(a, { children: [
        /* @__PURE__ */ e.jsx(n, { type: "body", variant: "productive", children: c.description }),
        /* @__PURE__ */ e.jsx(n, { type: "helper", variant: "productive", children: c.details })
      ] }),
      /* @__PURE__ */ e.jsx(n, { type: "body", variant: "productive", children: c.amount.toLocaleString(d, {
        currency: i.currency_code,
        style: "currency"
      }) })
    ] }, `${c.description}-tax`)) })
  ] }),
  /* @__PURE__ */ e.jsx(o, { $colorTheme: r, children: /* @__PURE__ */ e.jsxs(p, { children: [
    /* @__PURE__ */ e.jsx(n, { type: "heading", variant: "compact-02", children: t.totalLabel.toUpperCase() }),
    /* @__PURE__ */ e.jsx(n, { type: "heading", variant: "compact-02", children: (i.total_after_tax + y).toLocaleString(d, {
      currency: i.currency_code,
      style: "currency"
    }) })
  ] }) }),
  /* @__PURE__ */ e.jsxs(l, { children: [
    /* @__PURE__ */ e.jsx(n, { type: "body", variant: "productive", children: t.paymentAndCancellationPoliciesLabel }),
    /* @__PURE__ */ e.jsx(b, { $colorTheme: r, children: i.policies })
  ] })
] });
export {
  T as PriceBreakdown
};
